import type { IconProps } from '../types/IconProps.ts';
export const ColumnChartPlainIncreasing: IconProps = {
    name: 'ColumnChartPlainIncreasing',
    children: [
        `<path d="M5 21v-6M19 3v18M12 21V9" />`,
    ]
};